<template>
  <div id="App">

    <a-layout id="components-layout-demo-top" class="layout">
      <LayoutHeader></LayoutHeader>
      <!--<div style="font-size: 1.5rem">-->
        <!--<a href="http://cdn.pedesx.com/static/tcms/apk/20210609/com.repair.photo-1.0.0-2665.apk">&gt;&gt;&gt;立即下载 &lt;&lt;&lt;</a>-->
      <!--</div>-->
      <LayoutContent></LayoutContent>
      <LayoutContentDetailed></LayoutContentDetailed>
      <LayoutFooter></LayoutFooter>
    </a-layout>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layout-header";
import LayoutContent from "@/components/layout-content";
import LayoutContentDetailed from "@/components/layout-content-detailed";
import LayoutFooter from "@/components/layout-footer";

export default {
  data() {
    return {
      data: {}
    };
  },
  components: {
    LayoutHeader, LayoutContent, LayoutContentDetailed, LayoutFooter
  },
  methods: {},
};


</script>
<style>
#components-layout-demo-top .logo {
  width: 120px;
  height: 31px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px 24px 16px 0;
  float: left;
}
</style>
